export default __webpack_public_path__ + "static/media/483.284fb0ea.png";